// Unit conversion — metric = kg/km/ml, imperial = lb/mi/oz
export function fmtWeight(kg, units) {
  if (units === "imperial") return `${(kg * 2.20462).toFixed(1)} lb`;
  return `${kg} kg`;
}
export function fmtVolume(ml, units) {
  if (units === "imperial") return `${Math.round(ml / 29.5735)} oz`;
  return `${(ml / 1000).toFixed(1)}L`;
}
export function fmtDistance(km, units) {
  if (units === "imperial") return `${(km * 0.621371).toFixed(1)} mi`;
  return `${km} km`;
}
export function weightUnit(units) { return units === "imperial" ? "lb" : "kg"; }
export function volumeUnit(units) { return units === "imperial" ? "oz" : "ml"; }
export function toKg(value, units) { return units === "imperial" ? value * 0.453592 : value; }
// Infer preferred units from the browser locale/region. US (and LR/MM) default to imperial.
export function inferUnits() {
  try {
    const lang = (typeof navigator !== "undefined" && (navigator.language || navigator.languages?.[0])) || "";
    let region = "";
    try { region = (new Intl.Locale(lang).region || "").toUpperCase(); } catch {}
    if (!region && lang.includes("-")) region = lang.split("-")[1].toUpperCase();
    if (["US", "LR", "MM"].includes(region)) return "imperial";
  } catch {}
  return "metric";
}
export function fmtWeightDelta(kg, units) {
  const v = units === "imperial" ? kg * 2.20462 : kg;
  return `${v > 0 ? "+" : ""}${v.toFixed(1)} ${weightUnit(units)}`;
}
